import {styled,  Paper } from "@mui/material";

export const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
        backgroundColor: '#1A2027',
    }),
}));

export function percentage(numerator: number, denominator: number): number {
    let p = (numerator / denominator) * 100
    return withTwoDecimalPlaces(p)
}

export function withTwoDecimalPlaces(n: number) {
    return (Math.round(n * 100) / 100)
}

export function round(num: number): number {
    const decimal = num % 1;
    return decimal >= 0.5 ? Math.ceil(num) : Math.floor(num);
}